'use client';

import styled from 'styled-components';

import HeaderTitle from 'components/StaticPages/HeaderTitle';

const Akit = () => (
  <Root>
    <HeaderTitle>
      Befree стал членом Ассоциации компаний интернет-торговли!
    </HeaderTitle>

    <iframe
      v-lazy-load
      src="https://akit.ru/business/partners/befree-8/certificate"
      title="akit_cert"
      name="akit_cert"
      scrolling="yes"
      frameBorder="1"
      allowFullScreen
      className="iframe"
    />
  </Root>
);

const Root = styled.div`
  .iframe {
    display: block;
    margin: 20px auto;
    max-width: 100%;
    width: 450px;
    height: 900px;

    @media ${(p) => p.theme.device.laptop} {
      width: 906px;
      height: 1100px;
    }
  }
`;

export default Akit;
